import { intlLocale, type Locale } from "./config";

const shortMonths: Partial<Record<Locale, string[]>> = {
  es: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  pt: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
};

/** 1.234,5 in Spanish (es-CO) and Portuguese (pt-BR), 1,234.5 in English. */
export function formatNumber(locale: Locale, value: number, options: Intl.NumberFormatOptions = { maximumFractionDigits: 2 }) {
  return new Intl.NumberFormat(intlLocale[locale], options).format(value);
}

/** Prices are always published in USD; only the grouping and decimal marks follow the language. */
export function formatCurrency(locale: Locale, value: number, options: Intl.NumberFormatOptions = {}) {
  return new Intl.NumberFormat(intlLocale[locale], { style: "currency", currency: "USD", currencyDisplay: "narrowSymbol", maximumFractionDigits: 2, ...options }).format(value);
}

/** "8 sep 2026" in Spanish and "8 set 2026" in Portuguese (the library's house style, not Intl's
 * "sept" / "set."), "Sep 8, 2026" in English. `long` gives "8 de septiembre de 2026" /
 * "8 de setembro de 2026" / "September 8, 2026". ISO dates are read as UTC days. */
export function formatDate(locale: Locale, iso: string, month: "short" | "long" = "short") {
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso}T00:00:00Z` : iso);
  if (Number.isNaN(date.getTime())) return iso;
  const months = shortMonths[locale];
  if (months && month === "short") return `${date.getUTCDate()} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
  return new Intl.DateTimeFormat(intlLocale[locale], { day: "numeric", month, year: "numeric", timeZone: "UTC" }).format(date);
}
